import { useMemo } from "react";
import { EditablePreOrderNumber } from "../ui/EditablePreOrderNumber";
import type { FlowCellProps } from "./types";
import { useRecapFilteringContext } from "../../contexts/RecapContext";

export function OrderNumberCell({ flow }: FlowCellProps) {
  const { filteredPreOrders } = useRecapFilteringContext();

  const po = useMemo(
    () => filteredPreOrders.find((p) => p.id === flow.pre_order_id),
    [filteredPreOrders, flow.pre_order_id],
  );

  return (
    <EditablePreOrderNumber
      preOrderId={flow.pre_order_id}
      currentNumber={po?.pre_order_number}
      customerPoNumber={po?.customer_po_number}
    />
  );
}
